var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingContainer"},[_c('v-progress-circular',{attrs:{"size":"100","indeterminate":""}}),(_vm.showPhrase)?_c('p',{staticStyle:{"margin-top":"50px"}},[_vm._v(_vm._s(_vm.phrase))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }